// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"c4df8b52","107":"59d2d944","116":"a3507e71","232":"c4df8b52","274":"c4df8b52","293":"c4df8b52","300":"c4df8b52","462":"c4df8b52","487":"c4df8b52","700":"c4df8b52"}[chunkId] + ".chunk.css";
};